<template>
  <v-dialog
    v-model="viewerValue" 
    @input="$emit('closed')"
    max-width="700"
    >
    <v-card>
      <v-card-title
        class="grey lighten-2"
        primary-title
      >
        <v-spacer></v-spacer>
        <v-icon @click="close">close</v-icon>
      </v-card-title>
      <!-- <v-row class="pb-0 pr-3" cols="12">
        <v-col class="pb-0" xs="12">
          <v-switch
            class="float-right"
            v-model="isCutOff"
            label="Preview Cut-off"
          ></v-switch>
        </v-col>
      </v-row> -->
      <v-card-text class="text-center" v-if="media.publicID && media.isvideo">
        <custom-media-v2
          :media="campaignHelper.customPostMediaConfig(media, { videoDownload: true, overlay: isCutOff })"
        />
      </v-card-text>
      <v-card-text class="text-center" v-if="media.publicID && !media.isvideo">
        <custom-media-v2
          :media="campaignHelper.customPostMediaConfig(media, { overlay: isCutOff })"
        />
      </v-card-text>
      <v-card-text class="text-center" v-else>
        <v-img :src="media" v-if="!videoPlayer"></v-img>
        <video width="300" controls v-if="videoPlayer">
          <source :src="media" type="video/mp4">
          Your browser does not support HTML5 video.
        </video>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <a :href="media.url || media" download target="_blank">
          <v-btn><v-icon float-left>save_alt</v-icon>Download</v-btn>
        </a>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import CustomMediaV2 from '../../scoped/custom/CustomMediaV2';
import campaignHelper from '../Campaign/campaignHelper';
export default {
  name: 'PostMediaViewerModal',
  props: [
    'viewerValue',
    'media',
    'videoPlayer'
  ],
  components: {
    CustomMediaV2
  },
  data() {
    return {
      isCutOff: false,
      campaignHelper
    }
  },
  methods: {
    close() {
      this.viewerValue = false
      this.$emit('closed')
    }
  }
}
</script>



// WEBPACK FOOTER //
// PostMediaViewerModal.vue?29aa3824